import { Navigate, useLocation } from 'react-router-dom';
import { useCabinetMenuAccess } from '../hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
  path: string;
}

const ProtectedRoute = ({ children, path }: ProtectedRouteProps) => {
  const { canAccessMenu } = useCabinetMenuAccess();
  const location = useLocation();

  if (!canAccessMenu(path)) {
    // Redirect to ads-history if user doesn't have access
    return (
      <Navigate
        to="/cabinet/facebook/ads-history"
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
